import { ReactNode } from 'react'

type Props = {
    children: ReactNode
}

export const PopoverContentWrapper = ({ children }: Props) => <div className="flex flex-col gap-2 pb-4 pt-4">{children}</div>
